export const partnerData = [
    {
        id: 1,
        name: '',
        organization: 'MonSchool',
        desc: 'MonSchool is the first experiment on the Mon Platform, a brand of social platforms whose vision is to provide community run alternatives to large private platforms.'
    },
    {
        id: 2,
        name: '',
        organization: 'Debian ',
        desc: 'The Debian Project is an association of individuals who sharing a common goal to create a free operating system, available for everyone.'
    },
    {
        id: 3,
        name: '',
        organization: 'Wikimedia',
        desc: 'The Wikimedia foundation is part of the Wikimedia global movement whose mission is to bring free educational content to the whole world by working together with our community.'
    },
    {
        id: 4,
        name: '',
        organization: 'Hoppscotch',
        desc: 'It is an open source API development ecosystem crafted with minimalistic UI design. Requests and responses are also available in real time.'
    },
    {
        id: 5,
        name: '',
        organization: 'Parseable',
        desc: 'Parseable is an efficient log storage and query platform that focuses on ease of use and deployment. It enhances your logging stack, lets you observe them easily and aims to improve software reliability with better logging.'
    },
    {
        id: 6,
        name: '',
        organization: 'GramUp',
        desc: 'GramUp is a lightweight python program to backup your files. GramUp enables you unlimited cloud backup and easy restore functionality and that too for free.'
    },
    {
        id: 7,
        name: '',
        organization: 'BoxyHQ',
        desc: "BoxyHQ helps developers automate product security and provides low-code APIs to enable enterprise-compliant security via simple and efficient integrations."
    },
]